import React, { useState } from 'react';

const DisputeRequestComposer = ({ dispute, busy, onSubmit, onCancel }) => {
  const [recommendation, setRecommendation] = useState('administrator_review');
  const [amount, setAmount] = useState('');
  const [message, setMessage] = useState('');

  const submit = () => {
    if (message.trim().length < 10) return;
    const refundCents = ['full_refund', 'partial_refund'].includes(recommendation)
      ? Math.round(Number(amount) * 100)
      : 0;
    if (refundCents < 0 || !Number.isFinite(refundCents)) return;
    onSubmit({ recommendation, refundCents, message: message.trim() });
  };

  return (
    <section className="rounded-2xl border border-indigo-100 bg-white p-5 shadow-sm">
      <h3 className="font-black text-slate-900">Request administrator review</h3>
      <p className="mt-1 text-xs text-slate-500">
        This recommendation is sent to an administrator. It does not issue a refund or change dispute status.
      </p>
      <label className="mt-4 block text-[9px] font-black uppercase tracking-widest text-slate-400">
        Recommended outcome
        <select
          value={recommendation}
          onChange={(event) => setRecommendation(event.target.value)}
          className="mt-2 w-full rounded-xl bg-slate-50 px-3 py-3 text-sm font-bold text-slate-700"
        >
          <option value="administrator_review">Further administrator review</option>
          <option value="full_refund">Full refund</option>
          <option value="partial_refund">Partial refund</option>
          <option value="replacement">Replacement</option>
        </select>
      </label>
      {['full_refund', 'partial_refund'].includes(recommendation) && (
        <label className="mt-4 block text-[9px] font-black uppercase tracking-widest text-slate-400">
          Suggested amount (CAD, up to ${Number(dispute.order_total || 0).toFixed(2)})
          <input
            type="number"
            min="0.01"
            max={dispute.order_total || 0}
            step="0.01"
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
            className="mt-2 w-full rounded-xl bg-slate-50 px-3 py-3 text-sm font-bold text-slate-700"
          />
        </label>
      )}
      <label className="mt-4 block text-[9px] font-black uppercase tracking-widest text-slate-400">
        Summary for the administrator
        <textarea
          rows="4"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          className="mt-2 w-full rounded-xl bg-slate-50 px-3 py-3 text-sm font-medium text-slate-700"
          placeholder="Summarize what you reviewed and why you recommend this outcome."
        />
      </label>
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          disabled={busy || message.trim().length < 10}
          onClick={submit}
          className="rounded-xl bg-indigo-600 px-4 py-3 text-[9px] font-black uppercase tracking-widest text-white disabled:opacity-50"
        >
          {busy ? 'Sending…' : 'Send request'}
        </button>
        <button type="button" onClick={onCancel} className="rounded-xl bg-slate-100 px-4 py-3 text-[9px] font-black uppercase tracking-widest text-slate-600">
          Cancel
        </button>
      </div>
    </section>
  );
};

export default DisputeRequestComposer;
